import { render } from "./AppFooters.vue?vue&type=template&id=4ca85724&scoped=true"
const script = {}

import "./AppFooters.vue?vue&type=style&index=0&id=4ca85724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca85724"]])

export default __exports__